import React from 'react';
import './Error404.css';

export default function Error404() {
    return (
        <div className="page-content">
            <div className="page-top">Error 404!</div>
            <div className="text-text">
                <p className="page-text"> Page Not Found </p>
            </div>
        </div>
    );
}
